import $axios from "@/plugins/axioslib";
import appconfig from "@/appconfig";
import appConstants from "@/appConstants";
import errorMessage from "@/errormessage";

const state = {
  profile: {},
  users: [],
  memberCompanyInfo: {},
  security: {
    firstName: "",
    lastName: "",
    email: "",
    release:""
  },
  invoice: {
    firstName: "",
    lastName: "",
    email: "",
    release:""
  },
  payment: {
    firstName: "",
    lastName: "",
    email: "",
    release:""
  },
  legal: {
    firstName: "",
    lastName: "",
    email: "",
    release:""
  },
  qualification: {
    firstName: "",
    lastName: "",
    email: "",
    release:""
  },
  error: ""
};

const getters = {
  memberContact: (state: any) => state,
  memberCompanyInfo: (state: any) => state.memberCompanyInfo,
  fullname: (state: any) => state.profile.name,
  isPrimaryContact: (state: any) =>
    state.memberCompanyInfo ? state.memberCompanyInfo.IsPrimaryContact : false,
  error: (state: any) => state.error
};

const actions = {
  async getUserList({ commit }: any) {
    const url =
      appconfig.audience +
      "/api/members/users?pagenumber=0&pageSize=10000&sortby=email&desc=true";
    await $axios
      .get(url)
      .then(response => {
        commit("setObject", { key: "users", data: response.data });
      })
      .catch(err => {
        return Promise.reject(err);
      });
  },

  async setUserProfile({ commit }: any, data: any) {
    commit("setObject", { key: "profile", data: data });
  },

  async getUserCompanyInfo({ commit }: any) {
    const url = appconfig.audience + "/api/members/usercompanyinfo";

    await $axios
      .get(url)
      .then(response => {
        if (
          response.data.AdditionalContacts != null &&
          response.data.AdditionalContacts.length > 0
        ) {
          let contacttype = "";
          for (const contactinfo of response.data.AdditionalContacts) {
            switch (contactinfo.AdditionalContactType) {
              case appConstants.memberContactTypes.Security: {
                contacttype = "security";
                break;
              }
              case appConstants.memberContactTypes.Invoice: {
                contacttype = "invoice";
                break;
              }
              case appConstants.memberContactTypes.Payment: {
                contacttype = "payment";
                break;
              }
              case appConstants.memberContactTypes.Legal: {
                contacttype = "legal";
                break;
              }
              case appConstants.memberContactTypes.Qualification: {
                contacttype = "qualification";
                break;
              }
              default: {
                //statements;
                break;
              }
            }
            commit("setObject", {
              key: contacttype,
              data: {
                firstName: contactinfo.FirstName ? contactinfo.FirstName : "",
                lastName: contactinfo.LastName ? contactinfo.LastName : "",
                email: contactinfo.EmailAddress,
                release : contactinfo.ReleaseContactInfo
              }
            });
          }
        }
        commit("setObject", {
          key: "memberCompanyInfo",
          data: response.data
        });
        return Promise.resolve();
      })
      .catch(err => {
        return Promise.reject(err);
      });
  },

  async updateContact({ commit }: any, data: any) {
    const url = appconfig.audience + "/api/members/additionalcontacts";
    await $axios
      .put(url, data)
      .then(response => {
        return Promise.resolve();
      })
      .catch(err => {
        return Promise.reject(err);
      });
  },

  async setContact({ commit }: any, data: any) {
    commit("setObject", {
      key: data.contactType,
      data: data.contactInfo
    });
  },

  async setError({ commit }: any, data: any) {
    commit("setObject", {
      key: "error",
      data: errorMessage(data)
    });
    return Promise.resolve();
  }
};

const mutations = {
  setObject: (state: any, object: any) => {
    const { key, data } = object;
    state[key] = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
